import { z } from "zod/v4-mini";

import { ThresholdStep } from "@/uiKit/molecules/thresholds/ThresholdStep.tsx";
import { Schema, cz } from "@/utils/zodUtils.ts";

import { AGPStats, agpStatsSchema } from "./AGPStatsModel";

export type GlycemiaDistribution = Record<ThresholdStep, number>;

export type GlycemiaIndicatorsResponse = {
  meanGlycemia: number;
  numberOfHypoglycemia?: number;
  usagePercentage?: number;
  averageDailyMeasures?: number;
  glycemiaRanges?: GlycemiaDistribution;
  agpProfile?: AGPStats;
  hb1Ac?: number;
  coefficientOfVariation?: number;
};

export const emptyGlycemiaDistribution: GlycemiaDistribution = {
  severeHyperglycemia: 0,
  hyperglycemia: 0,
  normal: 0,
  hypoglycemia: 0,
  severeHypoglycemia: 0,
};

const noIndicatorsSchema = z.pipe(
  z.object({
    detail: z.literal("no data available"),
  }),
  z.transform(() => ({
    meanGlycemia: 0,
    numberOfHypoglycemia: 0,
    usagePercentage: 0,
    averageDailyMeasures: 0,
    glycemiaRanges: undefined,
    agpProfile: undefined,
    hb1Ac: 0,
    coefficientOfVariation: 0,
  })),
);

const indicatorsSchema: Schema<GlycemiaIndicatorsResponse> = cz.camelCaseObject({
  mean_glycemia: z.number(),
  number_of_hypoglycemia: cz.optional(z.number()),
  usage_percentage: cz.optional(z.number()),
  average_daily_measures: cz.optional(z.number()),
  glycemia_ranges: cz.optional(
    cz.camelCaseObject({
      severe_hyperglycemia: z.number(),
      hyperglycemia: z.number(),
      normal: z.number(),
      hypoglycemia: z.number(),
      severe_hypoglycemia: z.number(),
    }),
  ),
  agp_profile: cz.optional(agpStatsSchema),
  hb1ac: cz.optional(z.number()),
  coefficient_of_variation: cz.optional(z.number()),
});

export const glycemiaIndicatorsSchema: Schema<GlycemiaIndicatorsResponse> = z.union([
  noIndicatorsSchema,
  indicatorsSchema,
]);
